export const nDaysAgo = days => {
  const now = new Date()
  now.setDate(now.getDate() - days)
  return now
}
